<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Prodcut Composition</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Prodcut Composition List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Description</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let product of productCompositionData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                      }  ;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{product.productName}}</th>
                      <th scope="col">{{product.description}}</th>
                      <th scope="col">
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getProductCompositionById(product.productCompositionId)" data-toggle="modal" data-target="#exampleModalView"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
                    </th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="productCompositionData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->
  
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <p>Prodcut Composition List</p>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search product" [(ngModel)]="searchKey">
                            </form>
                            <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
                            <i class="bi bi-search" (click)="getProductCompositionByWildSearch(0,10)"></i>
                        </div>
                        <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                    </div>
                </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                  
                        <th style="width: 40%;">Name</th>
                        <th style="width: 40%;">Description</th>
                        <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
    
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let product of productCompositionData | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: pageNumber,
                            totalItems: totalRecords
                            }  ;let i = index">
        
                        <p style="width: 40%;">{{product.productName}}</p>
                        <p style="width: 40%;">{{product.description}}</p>         
                        <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                          <i *ngIf="actionControls.isView" (click)="getProductCompositionById(product.productCompositionId)" data-toggle="modal" data-target="#exampleModalView" class="bi bi-eye-fill"></i>
                        </p>                
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && productCompositionData.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>
        
          
            </div>

        </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Prodcut Composition
            <span data-dismiss="modal">
                <i class="bi bi-x-lg"></i>
            </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>Name</label>
                        <!-- <input formControlName="productName" type="text" class="form-control"> -->
                        <select class="form-control" formControlName="productName" aria-placeholder="enter product name">
                            <option *ngFor="let p of products" [value]="p.name">{{p.name}}</option>
                        </select>
                    </div>
                </div>
                
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                </div>
              
              
                <div class="col-md-12 col-lg-12">
                    <div formArrayName="productCompositionIngList">
                        <div *ngFor="let param of form.controls.productCompositionIngList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <!-- <input formControlName="name" placeholder="enter name" type="text" class="form-control"> -->
                                        <select class="form-control" formControlName="name" aria-placeholder="enter product name">
                                            <option *ngFor="let p of products" [value]="p.name">{{p.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <input formControlName="qty" placeholder="enter qty" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <select class="form-control" formControlName="uom" aria-placeholder="enter product name">
                                            <option *ngFor="let uom of uomData" [value]="uom.uomName">{{uom.uomName}}</option>
                                        </select>
                                        <!-- <input formControlName="uom" placeholder="enter uom" type="text" class="form-control"> -->
                                    </div>
                                </div>
                                <div class="col-md-2 col-lg-2">
                                    <div class="form-group">
                                        <input formControlName="price" placeholder="enter price" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addInfoObject()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeParamObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <!-- <div class="form-group">
                                        <button style="width: 100%;" (click)="removeParamObject(i)">Remove</button>
                                    </div> -->
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removeParamObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addProductComposition()" class="btn btn-primary">Add Prodcut Composition</button>
      </div>
    </div>
  </div>
  </div>
  </div>
  


  <!-- <div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        </div>
        <div class="modal-body">
    
          <div>
              <div class="row view" *ngFor="let customer of singleCustomerInfo">
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{customer.name}}" class="form-control">
                      </div>
                  </div>
                  
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{customer.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group" style="text-align: center;">
                          <label >Params</label>
                      </div>
                  </div>
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngFor="let params of customer.customerParamEntityList">
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.name}}" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.value}}" class="form-control">
                        </div>
                    </div>
                  </div>
              </div>
           
    
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
    </div> -->



<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Prodcut Composition
            <span data-dismiss="modal">
                <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body view">
    
          <div *ngFor="let product of singleproductCompositionData">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{product.productName}}" class="form-control">
                      </div>
                  </div>
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{product.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                
                
                  <div class="col-md-12 col-lg-12">
                          <div *ngFor="let list of product.productCompositionIngList;let i = index;let last = last">
                              <div class="row">
                                  <div class="col-md-3 col-lg-3">
                                      <div class="form-group">
                                          <input placeholder="enter name" value="{{list.name}}" type="text" class="form-control">
                                      </div>
                                  </div>
                                  <div class="col-md-3 col-lg-3">
                                      <div class="form-group">
                                          <input placeholder="enter qty" value="{{list.qty}}" type="text" class="form-control">
                                      </div>
                                  </div>
                                  <div class="col-md-3 col-lg-3">
                                      <div class="form-group">
                                          <input placeholder="enter uom" value="{{list.uom}}" type="text" class="form-control">
                                      </div>
                                  </div>
                                  <div class="col-md-3 col-lg-3">
                                      <div class="form-group">
                                          <input placeholder="enter price" value="{{list.price}}" type="text" class="form-control">
                                      </div>
                                  </div>
                              </div>
                          </div>
                  </div>
              </div>
           
    
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
    </div>